<div class="layout-ParentDiv innerDiv">
	<div class="layout-dashboard addPage"  >
  <div class="p-grid">
    <p-toast key="toastmsg" position="top-right"></p-toast>
    <div class="p-col-12 mainFormPadding">
        <div class="card">
            <form [formGroup]="homepagevideoform" *ngIf="this.homepagevideoform">
                <div class="p-fluid p-formgrid p-grid m-0">
                    <div class="p-field p-col-12 div-border p-p-0">
                        <h3 class="head-page-title">
                            {{pagetitle}}
                        </h3>
                    </div>
                </div>
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                        <div class="p-field p-col-4">
                            <label for="title">Title<span class="mandatory-feilds">*</span></label>
                            <input id="title" formControlName="title" type="text" pInputText
                                [ngClass]="{ 'is-invalid': ((submitted && f.title.errors) || (f.title.errors && (f.title.dirty || f.title.touched)))}">
                            <div *ngIf="((submitted && f.title.errors) || (f.title.errors && (f.title.dirty || f.title.touched)))"
                                class="invalid-feedback">
                                <div *ngIf="f.title.errors.required">Title is required</div>
                            </div>
                        </div>
                             <div class="p-field p-col-4">
                                <label for="youtubechannelurl">Youtube URL <span class="mandatory-fields">*</span>
                                </label>
                                <input formControlName="youtubechannelurl" id="youtubechannelurl" type="text" pInputText
                                    class="form-control" autocomplete="off"
                                    [ngClass]="{ 'is-invalid': ((submitted && f.youtubechannelurl.errors) || (f.youtubechannelurl.errors && (f.youtubechannelurl.dirty || f.youtubechannelurl.touched))) }"
                                    placeholder="eg. https://www.youtube.com/embed">
                                <div *ngIf="((submitted && f.youtubechannelurl.errors) || (f.youtubechannelurl.errors && (f.youtubechannelurl.dirty || f.youtubechannelurl.touched)))"
                                    class="invalid-feedback">
                                    <div *ngIf="f.youtubechannelurl.errors.required">Youtube URL is required</div>
                                    <div *ngIf="f.youtubechannelurl.errors.pattern">Invalid Youtube Url. e.g.
                                        https://www.youtube.com/embed/PIqSPfvikCU</div>
                                </div>
                            </div>
                        <div class="p-field p-col-4 p-0">
                            <div class="statusdiv ">
                                <label for="status">Status</label>
                                	<div class="swichTable">
										<p-inputSwitch formControlName="status">

										</p-inputSwitch> 
									</div>
                                <!-- <p-dropdown inputId="status" [options]="statuses" formControlName="status"
                                    placeholder="Select" optionLabel="label"
                                    (ngModelChange)="onStatusSelect($event)"></p-dropdown>
                                <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                    <div *ngIf="f.status.errors.required">Please Select Status</div>
                                </div> -->
                            </div>

                        </div>

                        <!-- For sequence -->
                        <div class="p-field">
                            <label for="sequence">Sequence<span class="mandatory-feilds">*</span></label>
                            <input id="sequence" formControlName="sequence" type="number" min="1" max="99" pInputText  (input)="limitSequence($event)"
                                [ngClass]="{ 'is-invalid': ((submitted && f.sequence.errors) || (f.sequence.errors && (f.sequence.dirty || f.sequence.touched)))}">
                            <div *ngIf="((submitted && f.sequence.errors) || (f.sequence.errors && (f.sequence.dirty || f.sequence.touched)))"
                                class="invalid-feedback">
                               <div *ngIf="f.sequence.errors.required"> Sequence is required </div>
                                    <div *ngIf="f.sequence.errors?.min">Sequence must be at least 1.</div>
                                    <div *ngIf="f.sequence.errors?.max">Sequence cannot be greater than 55.</div>
                            </div>
                        </div>
                        
                        <div class="p-field p-col-12 uploadBtn">
                            <div class="subTitleLable">
                                <h4>Thumbnail</h4> 
                            </div>
                            <!-- <p-fileUpload chooseLabel="Upload" uploadLabel="Thumbnail Image"
                                cancelLabel="Cancel" accept="image/*" maxFileSize="{{imageSize}}" auto="auto"
                                customUpload="true" (uploadHandler)="picUploader($event)"
                                (onRemove)="removeFile($event)">
                                <ng-template pTemplate="content">
                                </ng-template>
                            </p-fileUpload> -->
                            <p-fileUpload #fileUpload mode="advanced" name="file" chooseLabel="Upload" uploadLabel="Thumbnail Image" cancelLabel="Cancel"
                                accept="image/*" maxFileSize="1000000" auto="false" customUpload="true"
                                (onSelect)="onFileSelect($event)" (onRemove)="removeFile($event)">
                                <ng-template pTemplate="content">
                                </ng-template>
                            </p-fileUpload>
                            <div class="error-msg" *ngIf="notproduct">
                                Please Upload Thumbnail Image
                            </div>
                        </div>
                    </div>
                    <div class="instruction">
                        <p>Instructions: </p>
                        <ul>
                            <li>1) The Home Page video must be exactly 739px width × 412px height for proper display. </li>
                            <li>2) Keep the file size optimized for fast loading and better performance, with a maximum size of 1 MB. </li>  
                        </ul>
                    </div>
                    
                    <div class="lineborderHR">
                        <hr>
                    </div>
                    <div class="button-set p-col-12 d-flex p-fluid p-jc-md-end bottom-footer  mt-5 mb-5">
                        <div class="p-formgrid p-grid">
                            <p-toast></p-toast>
                            <button type="text" (click)="onSubmit()" pButton icon="pi pi-check" label="Save"
                                class="p-button-success save-btn p-mr-3" style="width: auto"></button>
                            <button type="text" (click)="backLink()" pButton icon="pi pi-times" label="Cancel"
                                class="p-button-danger cancel-btn" style="width: auto"></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
    </div>
    <p-dialog [(visible)]="cropDialog" [closable]="false" [modal]="true" [appendTo]="'body'" [style]="{ width: '660px' }"
        styleClass="custom-crop-dialog">
    
        <ng-template pTemplate="header">
            <div class="crop-header-wrapper">
                <div class="crop-header-icon-box">
                    <i class="pi pi-image header-icon"></i>
                </div>
    
                <div class="crop-header-text">
                    <h5 class="crop-dialog-title">
                        {{ cropDialogTitle }}
                    </h5>
    
                    <p class="crop-dialog-subtitle">
                        {{ cropDialogSubtitle }}
                    </p>
                </div>
            </div>
        </ng-template>
    
        <div class="crop-dialog-content-wrapper">
    
            <div class="crop-toolbar-bar mb-3">
    
                <div class="toolbar-hint">
                    <i class="pi pi-sliders-h mr-2 hint-icon"></i>
                    <span>Zoom & Scale</span>
                </div>
    
                <div class="zoom-actions">
    
                    <button type="button" pButton icon="pi pi-search-plus" label="Zoom In" class="crop-btn zoom-btn"
                        (click)="zoomIn()">
                    </button>
    
                    <button type="button" pButton icon="pi pi-search-minus" label="Zoom Out" class="crop-btn zoom-btn"
                        (click)="zoomOut()">
                    </button>
    
                    <button type="button" pButton icon="pi pi-refresh" label="Reset" class="crop-btn reset-btn"
                        (click)="resetZoom()">
                    </button>
    
                </div>
    
            </div>
    
            <div class="cropper-frame mb-3">
    
                <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                    [aspectRatio]="739 / 412" [resizeToWidth]="739" [resizeToHeight]="412" [transform]="transform"
                    format="jpeg" (imageCropped)="imageCropped($event)">
                </image-cropper>
    
            </div>
    
            <div class="error-msg crop-error-msg" *ngIf="croppedImageError">
    
                {{ croppedImageError }}
            </div>
    
            <div class="cropped-preview-box" *ngIf="croppedImage">
                <div class="preview-header">
                    <div class="preview-title">
                        <i class="pi pi-eye mr-2 text-primary"></i>
                        <span>Live Cropped Preview</span>
                    </div>
                    <span class="preview-ratio-badge">
                        {{ cropPreviewLabel }}
                    </span>
                </div>
                <div class="preview-img-container">
                    <img [src]="croppedImage" alt="Cropped Preview" class="preview-img" />
                </div>
            </div>
        </div>
    
        <ng-template pTemplate="footer">
            <div class="dialog-footer-actions">
                <button type="button" pButton label="Cancel" icon="pi pi-times" class="cancel-action-btn"
                    (click)="onCropCancel()">
                </button>
                <button type="button" pButton label="Use Image" icon="pi pi-check" class="use-image-btn"
                    (click)="applyCrop()" [disabled]="!!croppedImageError || !croppedImage">
                </button>
            </div>
        </ng-template>
    
    </p-dialog>
    </div>